export default "__VITE_ASSET__ChEK3LMU__"